import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../services/api.service';
import { buildHttpParams } from '../utils';
import { DashboardSummary } from './dashboard.model';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private baseUrl = 'dashboard/';

  constructor(private apiService: ApiService) {}

  getSummary(date?: string): Observable<DashboardSummary> {
    const params = date ? buildHttpParams({ date }) : undefined;
    return this.apiService.get<DashboardSummary>(this.baseUrl + 'summary/', params);
  }
}
